/** @jsxImportSource @emotion/react */
import React from 'react';
import { CircularProgress } from '@mui/material';
import styles from './styles';

interface ConfirmButtonProps {
    setEditModeActive: React.Dispatch<React.SetStateAction<boolean>>;
    isEditMeetingRoomBookingLoading: boolean;
    startTimeError: string;
    endTimeError: string;
    onSaveClick: () => void;
    isStartTimeChanged: boolean;
    isEndTimeChanged: boolean;
    checkedRepeatMode: boolean;
    isBookingTimeIsFilled: boolean;
}

function ConfirmButton({
    setEditModeActive,
    isEditMeetingRoomBookingLoading,
    startTimeError,
    endTimeError,
    onSaveClick,
    isStartTimeChanged,
    isEndTimeChanged,
    checkedRepeatMode,
    isBookingTimeIsFilled,
}: ConfirmButtonProps) {
    const onEditBtnClickHandler = () => {
        onSaveClick();
        setEditModeActive(true);
    };

    const isDisabled = !(
        !checkedRepeatMode &&
        isBookingTimeIsFilled &&
        !startTimeError &&
        !endTimeError &&
        (isStartTimeChanged || isEndTimeChanged)
    );

    return (
        <div css={styles.btnWrapperStyles}>
            <button
                disabled={isDisabled}
                type="button"
                css={styles.editBtnStyles({ isDisabled })}
                onClick={onEditBtnClickHandler}
            >
                {isEditMeetingRoomBookingLoading ? (
                    <CircularProgress sx={{ color: 'white' }} size={20} />
                ) : (
                    'Confirm'
                )}
            </button>
        </div>
    );
}

export default ConfirmButton;
